import React from "react";
import { Badge } from "components/ui/badge";
import { CallOutcome } from "./types";
import { OUTCOME_LABELS } from "./selectors";

const OUTCOME_CLASSES: Record<CallOutcome, string> = {
  ANSWERED_FROM_KNOWLEDGE: "bg-green-100 text-green-800 border-green-200",
  APPOINTMENT_REQUESTED: "bg-blue-100 text-blue-800 border-blue-200",
  FOLLOW_UP_NEEDED: "bg-amber-100 text-amber-800 border-amber-200",
  UNRESOLVED: "bg-red-100 text-red-800 border-red-200",
  APPOINTMENT_SCHEDULED: "bg-emerald-100 text-emerald-800 border-emerald-200",
};

function OutcomeBadge({ outcome }: { outcome: CallOutcome }) {
  return (
    <Badge variant="outline" className={OUTCOME_CLASSES[outcome]}>
      {OUTCOME_LABELS[outcome]}
    </Badge>
  );
}

export default OutcomeBadge;
